import * as u from '../utils';

export default () => {
    const checkoutButtons = document.querySelectorAll('.quote-tease__cart');
    const deleteButtons = document.querySelectorAll('.quote-tease__bin');
    const modal = document.querySelector('.modal--quote');
    let deletionId = null;

    if (checkoutButtons.length < 1) {
        return false;
    }

    // Setup checkout controls
    const handleCheckout = (e) => {
        const id = e.currentTarget.dataset.id;

        if (!id) {
            return false;
        }

        u.postForm(WP.checkout, { quote_id: id }); // eslint-disable-line camelcase
    };

    for (const el of checkoutButtons) {
        el.addEventListener('click', handleCheckout);
    }

    // Setup delete controls
    const handleDeleteButton = () => {
        // Send request to delete
        const data = new FormData();
        data.append('action', 'quote_delete');
        data.append('security', WP.nonce);
        data.append('quote_id', deletionId);

        let responseStatus;

        fetch(WP.ajax, {
            method: 'POST',
            body: data,
        })
            .then((response) => {
                responseStatus = response.status;
                return response.json();
            })
            .then((response) => {
                switch (responseStatus) {
                    case 200:
                    case 201:
                    case 202:
                        if (response.success) {
                            // Display WP success message
                            u.displayWooSuccessMessage(response.data.message);

                            // Remove table item
                            document.querySelector(`.saved-quotes__item[data-id="${deletionId}"]`).remove();

                            if (document.querySelectorAll('.saved-quotes__item').length < 1) {
                                document.querySelector('.saved-quotes__items').remove();
                            }
                        } else {
                            u.displayWooErrorMessage(response.data.message);
                        }

                        break;
                    default:
                        u.displayWooErrorMessage(WP.translate.error);
                        break;
                }

                // Close modal
                u.removeClass(modal, 'is-active');
                modal.querySelector('[data-action="delete"]').removeEventListener('click', handleDeleteButton);
                deletionId = null;
            })
            .catch(() => {
                u.displayWooErrorMessage(WP.translate.error);

                // Close modal
                u.removeClass(modal, 'is-active');
                modal.querySelector('[data-action="delete"]').removeEventListener('click', handleDeleteButton);
                deletionId = null;
            });
    };

    const closeModal = () => {
        u.removeClass(modal, 'is-active');
        modal.querySelector('[data-action="delete"]').removeEventListener('click', handleDeleteButton);
        deletionId = null;
    };

    modal.querySelector('[data-action="cancel"]').addEventListener('click', closeModal);

    const handleDelete = (e) => {
        deletionId = e.currentTarget.dataset.id;
        modal.querySelector('.modal__content').innerHTML = document.querySelector(
            `.saved-quotes__item[data-id="${deletionId}"] .quote-tease__title a`
        ).innerHTML;

        u.addClass(modal, 'is-active');
        modal.querySelector('[data-action="delete"]').addEventListener('click', handleDeleteButton);
    };

    for (const el of deleteButtons) {
        el.addEventListener('click', handleDelete);
    }
};
